import { rei } from "@/services/api"

class AnotacoesCadastroService {
  static getAnotacoes (params = null) { let query = []
    query.push(params.cartorio_id ? 'cartorio_id=' + params.cartorio_id : '')
    query.push(params.registro_id ? 'registro_id=' + params.registro_id : '')
    return rei.get(`registro-anotacao-cadastro?${query.join('&')}`).then((res) => res.data)
  }

  static saveAnotacoes (anotacao) {
    return rei.post(`registro-anotacao-cadastro`, anotacao).then((res) => res.data)
  }

  static updateAnotacoes (anotacao, id) {
    return rei.put(`registro-anotacao-cadastro/${id}`, anotacao).then((res) => res.data)
  }

  static excludeAnotacoes (id) {
    return rei.delete(`registro-anotacao-cadastro/${id}`).then((res) => res.data)
  }
}

export default AnotacoesCadastroService
